function createAsyncMemorizer(callback) {
  let promise = null;

  return () => {
    if (!promise) {
      promise = new Promise((res) => {
        callback()
          .then(res)
          .catch((error) => {
            promise = null;
            throw error;
          });
      });
    }

    return promise;
  };
}

export default createAsyncMemorizer;
